import {
  BrainIcon,
  CompassIcon,
  HourglassIcon,
  RepeatIcon,
  RotateCcwIcon,
  RouteIcon,
  SproutIcon,
  SunIcon,
} from 'lucide-react'

export const CHECKOUT_URL = 'https://mega-pack-vida-con-proposito.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/v6k3uu1JoWdopvs4Mb32mT/Imagen_de_Codex_26_sept_2026,_16_08_04.png'

export const PRODUCT_NAME = 'MEGA PACK REINICIA TU VIDA™'
export const PACK_IMAGE_ALT = 'MEGA PACK REINICIA TU VIDA™: 6 tomos digitales y 5 bonos incluidos'
export const PRICE = '$19.990'
export const BONUS_TOTAL = '$39.950'

export const META_PIXEL_ID = '2226605141499138'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: RepeatIcon,
    title: 'VIVÍS EN PILOTO AUTOMÁTICO',
    desc: 'Los días pasan entre obligaciones, pendientes y problemas. Sabés que querés cambiar, pero terminás repitiendo prácticamente la misma rutina.',
  },
  {
    icon: BrainIcon,
    title: 'TENÉS DEMASIADAS COSAS EN LA CABEZA',
    desc: 'Pendientes, preocupaciones, decisiones, objetivos y responsabilidades se acumulan hasta que no sabés qué atender primero.',
  },
  {
    icon: RotateCcwIcon,
    title: 'EMPEZÁS PERO NO MANTENÉS',
    desc: 'Intentás organizarte, crear nuevos hábitos o comenzar proyectos, pero después de algunos días volvés a lo mismo y sentís que tenés que empezar otra vez.',
  },
  {
    icon: HourglassIcon,
    title: 'SEGUÍS POSTERGANDO',
    desc: 'Sabés que existen decisiones y cambios que necesitás hacer, pero pasan las semanas esperando tener más tiempo, energía, claridad o motivación.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'VOLVÉ A TOMAR EL CONTROL DE TU VIDA',
    desc: 'Identificá dónde estás viviendo en piloto automático, evaluá las principales áreas de tu vida, detectá qué está drenando tu tiempo y energía y comenzá a recuperar tus verdaderas prioridades.',
  },
  {
    title: 'ORDEN MENTAL Y CLARIDAD',
    desc: 'Aprendé a descargar tu mente, organizar pendientes, reducir distracciones, diferenciar preocupación de acción y construir una rutina sencilla para recuperar claridad.',
  },
  {
    title: 'HÁBITOS PARA UNA VIDA MEJOR',
    desc: 'Comprendé por qué abandonamos cambios, aprendé a comenzar con hábitos pequeños, reducir la procrastinación, diseñar un entorno favorable y construir mayor constancia.',
  },
  {
    title: 'PROPÓSITO Y DIRECCIÓN PERSONAL',
    desc: 'Descubrí qué querés realmente, identificá tus valores, fortalezas y prioridades, definí objetivos y comenzá a construir una dirección personal para los próximos meses.',
  },
  {
    title: 'RELACIONES, LÍMITES Y BIENESTAR',
    desc: 'Aprendé a revisar tus relaciones, establecer límites, comunicar lo que necesitás, proteger tu tiempo y energía y dejar de colocarte siempre al final de tus prioridades.',
  },
  {
    title: 'TU NUEVO PLAN DE VIDA',
    desc: 'Integrá todo lo aprendido y convertí tus prioridades, objetivos y hábitos en un plan personal de 90 días con acciones semanales, revisiones y herramientas para continuar avanzando.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: 'DIARIO DE GRATITUD Y REFLEXIÓN · 30 DÍAS',
    desc: 'Un diario guiado para detenerte unos minutos cada día, reconocer lo positivo, observar cómo te sentís, reflexionar sobre tus decisiones y registrar aprendizajes durante 30 días.',
    value: '$7.990',
  },
  {
    title: 'PLANNER REINICIA TU VIDA · 90 DÍAS',
    desc: 'Un sistema de planificación para organizar tres objetivos principales, hábitos, semanas, prioridades y acciones durante los próximos 90 días.',
    value: '$5.990',
  },
  {
    title: '100 PREGUNTAS PARA CONOCERTE MEJOR',
    desc: '100 preguntas organizadas en 10 áreas para reflexionar sobre tu historia, fortalezas, hábitos, relaciones, miedos, valores, prioridades, sueños y futuro.',
    value: '$6.990',
  },
  {
    title: 'DESAFÍO REINICIA TU VIDA · 21 DÍAS',
    desc: '21 pequeñas misiones para limpiar distracciones, recuperar tiempo, ordenar prioridades, comenzar hábitos, resolver pendientes y volver a avanzar mediante acciones concretas.',
    value: '$8.990',
  },
  {
    title: 'KIT DE CLARIDAD, HÁBITOS Y ORGANIZACIÓN PERSONAL',
    desc: '15 herramientas prácticas con planners, trackers, mapas, checklists y plantillas para organizar pensamientos, objetivos, hábitos, tiempo, prioridades y tareas.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: RouteIcon,
    title: 'MENOS CONFUSIÓN',
    desc: 'Dejá de intentar cambiar todo al mismo tiempo y seguí una ruta organizada para identificar qué necesita atención y cuál puede ser tu siguiente paso.',
  },
  {
    icon: SunIcon,
    title: 'MÁS CLARIDAD',
    desc: 'Ordená pendientes, prioridades y objetivos para comprender mejor qué querés mantener, qué necesitás cambiar y hacia dónde querés avanzar.',
  },
  {
    icon: SproutIcon,
    title: 'MEJORES HÁBITOS',
    desc: 'Aprendé a comenzar con acciones pequeñas, reducir la procrastinación y construir rutinas más realistas sin depender constantemente de la motivación.',
  },
  {
    icon: CompassIcon,
    title: 'UNA NUEVA DIRECCIÓN',
    desc: 'Convertí todo lo aprendido en objetivos y acciones concretas para construir un plan personal que puedas adaptar a tu propia realidad.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Sentía que tenía demasiadas cosas pendientes y no sabía qué resolver primero. Lo que más me ayudó fue dejar de intentar cambiar todo junto y comenzar a organizar mis prioridades paso a paso.',
    author: 'Mariana López',
    meta: 'Emprendedora, 34 años · Buenos Aires, Argentina',
  },
  {
    quote:
      'Había probado planners y métodos de hábitos, pero siempre los abandonaba. Entender cómo reducir cada hábito a una versión pequeña me ayudó a crear una rutina mucho más realista.',
    author: 'Javier Gómez',
    meta: 'Comerciante, 39 años · Córdoba, Argentina',
  },
  {
    quote:
      'Lo que necesitaba era claridad. Tenía objetivos, ideas y pendientes por todos lados. Los ejercicios me ayudaron a ordenar lo que realmente quería priorizar durante los próximos meses.',
    author: 'Carolina Rodríguez',
    meta: 'Administrativa, 31 años · Montevideo, Uruguay',
  },
  {
    quote:
      'Siempre decía que cuando tuviera más tiempo iba a empezar a organizarme. El desafío de 21 días me gustó porque cada día tenía una acción concreta y no tenía que intentar resolver toda mi vida de golpe.',
    author: 'Alejandro Martínez',
    meta: 'Independiente, 42 años · Santiago, Chile',
  },
  {
    quote:
      'El planner de 90 días fue de las herramientas que más utilicé. Poder ver mis objetivos, hábitos y prioridades en un mismo lugar me dio una estructura mucho más clara para organizarme.',
    author: 'Lucía Sánchez',
    meta: 'Emprendedora, 36 años · Guadalajara, México',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El sistema está organizado para que puedas comenzar desde tu situación actual y avanzar paso a paso.',
  },
  {
    q: '¿Qué voy a encontrar dentro?',
    a: '6 tomos enfocados en control personal, claridad mental, hábitos, propósito, relaciones y planificación, además de 5 bonos prácticos.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Encontrarás ejercicios, evaluaciones, planners, trackers, checklists, preguntas de reflexión y herramientas para aplicar lo aprendido.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos con tu compra.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizás un único pago de $19.990. No existen mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Una vez confirmado el pago recibís acceso digital al material.',
  },
  {
    q: '¿Esto reemplaza ayuda profesional?',
    a: 'No. Es un producto educativo de desarrollo y organización personal y no reemplaza atención médica, psicológica, financiera o profesional cuando sea necesaria.',
  },
  {
    q: '¿Puedo avanzar a mi ritmo?',
    a: 'Sí. Podés utilizar los tomos y herramientas según tu propio ritmo y volver a consultarlos cuando lo necesites.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Podés comunicarte con nuestro correo de soporte para consultas relacionadas con tu compra y acceso.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Valentina G.', city: 'Buenos Aires', country: 'Argentina', minutes: 2 },
  { name: 'Martín R.', city: 'Córdoba', country: 'Argentina', minutes: 4 },
  { name: 'Camila F.', city: 'Rosario', country: 'Argentina', minutes: 7 },
  { name: 'Diego S.', city: 'Mendoza', country: 'Argentina', minutes: 10 },
  { name: 'Florencia P.', city: 'La Plata', country: 'Argentina', minutes: 13 },
  { name: 'Sofía M.', city: 'Mar del Plata', country: 'Argentina', minutes: 17 },
  { name: 'Nicolás A.', city: 'Tucumán', country: 'Argentina', minutes: 21 },
  { name: 'Julieta B.', city: 'Salta', country: 'Argentina', minutes: 26 },
  { name: 'Lucas D.', city: 'Neuquén', country: 'Argentina', minutes: 32 },
  { name: 'Agustina C.', city: 'Santa Fe', country: 'Argentina', minutes: 38 },
  { name: 'Paula V.', city: 'Bahía Blanca', country: 'Argentina', minutes: 43 },
  { name: 'Tomás L.', city: 'Posadas', country: 'Argentina', minutes: 49 },
]
